export class Pubsub {
    obj: { [key: string]: Function[] } = {};

    listen(key: string, callback: Function) {
        this.obj[key] = this.obj?.[key] || [];
        this.obj[key].push(callback);

        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const that = this;
        return function unListen() {
            that.obj[key] = (that.obj[key] || []).filter(fun => fun !== callback);
        };
    }

    // 另外一个名字， 好像subscribe名字比listen好点
    subscribe(key: string, callback: Function) {
        return this.listen(key, callback);
    }

    publish(key: string, value?: any) {
        const funs = this.obj[key] || [];
        funs.forEach(callback => callback(value));
    }
}
